<template>
  <h1>Active Banners</h1>

  <div class="flex flex-column justify-center gap-10">
    <div class="w-3/5 relative overflow-x-auto shadow-md">
      <div class="flex items-center justify-end flex-column flex-wrap space-y-4 p-4 bg-white">
        <a :href="currentUrl + '/create'" class="text-white hover:text-white hover:no-underline bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none">
          Add Banner
        </a>
      </div>
      <table class="w-full text-sm text-left text-gray-500">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50">
        <tr>
          <th scope="col" class="px-6 py-3">Company</th>
          <th scope="col" class="px-6 py-3">Banner Start Date</th>
          <th scope="col" class="px-6 py-3">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="companies.length === 0">
          <td colspan="3" class="px-6 py-4 text-center text-gray-500">
            No active banners
          </td>
        </tr>
        <tr v-for="(company, id) in companies" :key="id" class="odd:bg-white even:bg-gray-50 border-b">
          <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
            {{ company.name }}
          </th>
          <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">{{ company.created_at }}</th>
          <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
            <a :href="`banners/${id}/edit`">Edit</a>
          </th>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerList',
  props: {
    companies: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentUrl() {
      return window.location.href;
    }
  }
}
</script>
